<template  >


    <v-container style="width:100vw;height:100vh;background: #373737;" >


        <v-row align="center" justify="center" class="mx-auto" style="margin-top:100px;max-width:1800px;">
            <v-btn dark class="text-lowercase font-weight-light" router
                   :to="'/admin'" tile text>
                Stats
            </v-btn>

            <v-btn dark router :to="'/db-admin'" class="text-lowercase font-weight-light"  text>
                DB
            </v-btn>
          <v-btn dark router :to="'/admin_payouts'" class="text-lowercase font-weight-light"  text>
            Payouts
          </v-btn>
          <v-btn dark router :to="'/admin_spons'" class="text-lowercase font-weight-light"  text>
            Spons
          </v-btn>

            <v-col cols="12" align="center">
                <v-card >

                    <v-btn style="position: absolute; right: -3px; top: -6px;" @click="show_all=!show_all" icon>
                        <v-icon v-if="!show_all">
                            😎
                        </v-icon>
                        <v-icon v-else>
                            🤓
                        </v-icon>

                    </v-btn>
                    <v-row class="px-4">
                        <v-col>
                            <v-select

                                    :items="show_all? tables_all:tables"
                                    label="Kategori"
                                    color="black"
                                    @change="get_schema"
                            ></v-select>
                        </v-col>

                    </v-row>




                    <v-data-table
                        :page.sync="force_page"
                        @update:page="page_update"
                            :items="items"
                            :server-items-length="total_length"
                            :items-per-page.sync="items_per_page"
                            :headers="headers"
                            single-select
                            item-key="name"
                            no-data-text="Välj en kategori"
                            no-results-text="Inga träffar"
                            :search="search"
                            @click:row="view_more"
                            class="elevation-1"
                            :loading="is_loading"
                            loading-text="Hmm, laddar o dä"


                    >

                        <template v-slot:item.USER_NAME="{ item }">
                            <div style="max-width: 150px; overflow: hidden;">{{ item.USER_NAME}}</div>
                        </template>
                        <template v-slot:item.EMAIL="{ item }">
                            <div style="max-width: 150px; overflow: hidden;">{{ item.EMAIL}}</div>
                        </template>
                        <template v-slot:item.MESSAGE="{ item }">
                            <div style="max-width: 150px; overflow: hidden;">{{ item.MESSAGE}}</div>
                        </template>
                      <template
                          v-slot:header="{ props: { headers } }"
                      >
                        <thead>
                        <tr>
                          <th :key="index" v-for="(header,index) in headers">
                            <v-text-field
                                clearable
                              v-model="header.filter"
                              v-on:input="filter_change"
                            >

                            </v-text-field>
                          </th>
                        </tr>
                        </thead>
                      </template>



                    </v-data-table>
                </v-card>
            </v-col>



        </v-row>


        <v-dialog
                v-model="edit_row"
                max-width="690"
        >
            <v-card v-if="row_in_edit!==null">



                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col v-if="table==='streamers'" align="center" cols="12">
                                <v-btn
                                        block
                                        class="mx-auto"
                                        v-if="table==='streamers'"
                                        color="teal darken-1"
                                        text
                                        @click="login"
                                >
                                    Logga in som {{row_in_edit["USER_NAME"]}}
                                </v-btn>
                            </v-col>
                            <v-col v-for="(header,index) in headers_all" :key="index" cols="12">
                                <v-text-field :hint="header.type"  :readonly="header.pk===1" v-model="row_in_edit[header.name]" :label="header.notnull===1?header.name+'*':header.name"></v-text-field>
                            </v-col>


                        </v-row>
                    </v-container>
                </v-card-text>

                <v-card-actions>

                    <v-spacer></v-spacer>



                    <v-btn
                            color="teal darken-1"
                            text
                            @click="update_row"
                    >
                        Uppdatera
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </v-container>

</template>

<script>


    export default {
        name: "Admin-db",
        components:{},

        data:function(){
            return{
              items_per_page:15,
              search_by:{},
              total_length:0,
              offset:0,
              force_page:1,
              page:0,
              is_loading:false,
              selected_data:null,
              items:[],
              table:null,
                headers:[],
                headers_all:[],
                show_all:false,
                edit_row:false,
                row_in_edit:null,
                search:"",
                tables:[
                    "activity_cards",
                    "cards",
                    "deleted",
                    "deposits",
                    "messages",
                    "packs",
                    "payments",
                    "spons_results",
                    "status",
                    "streamer_styles",
                    "streamers"
                ],
                tables_all:[
                    "activity_card_models",
                    "activity_cards",
                    "card_models",
                    "card_ranks",
                    "cards",
                    "cards_in_trade",
                    "collections",
                    "deleted",
                    "deposits",
                    "donations_widget",
                    "events",
                    "fees",
                    "hicards_widget",
                    "messages",
                    "pack_purchase",
                    "packs",
                    "password_resets",
                    "payment_callbacks",
                    "payment_requests",
                    "payments",
                    "spons_results",
                    "stats",
                    "status",
                    "streamelements_api",
                    "streamer_styles",
                    "streamers",
                    "trades",
                    "twitch_callbacks",
                    "twitch_users"

                ],
                headers_of_uninterest:["SALT","PASSWORD_HASH","IS_ADMIN","ACCESS_TOKEN","PAYDAY","REQUEST_TOKEN","STATIC_FEE","DYNAMIC_FEE","SWISH_ID","CLIENT_ID","STREAMLABS_ID"],
                custom_check:["USER_NAME"],
                custom_action:{
                    "USER_NAME":''
                }



            }
        },
        methods:{

          filter_change(){
            this.get_data();
          },

            page_update(data){
              this.page=data-1;
              console.log(this.page);
              this.get_data();
            },


            login:function(){
                let http = new XMLHttpRequest();
                http.withCredentials = true;
                let url = '/api/admin-login-any?';
                let params = 'username='+this.row_in_edit["SID"]+"&password=blaha";
                let self=this;
                http.open('POST', url, true);

                http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
                http.onreadystatechange = function() {//Call a function when the state changes.


                    if(http.readyState === 4 && http.status === 401) {

                        self.$store.commit("update_snackbar","Hmm ett fel inträffade");

                    }

                    else if(http.readyState === 4 && http.status === 200){

                        self.$store.commit("update_snackbar","Hihi Hackerman");

                        setTimeout(function(){
                            window.location.reload()
                        },500)

                    }

                    else if(http.readyState === 4 && http.status !== 200){

                        self.$store.commit("update_snackbar","Hmm ett fel inträffade");

                    }

                };

                http.send(params);
            },

            update_row:function(){
                let http = new XMLHttpRequest();
                http.withCredentials = true;

                let url = '/api/adminUpdate?';
                let params = '&table='+this.table;
                let primarykey="";
                for(let i=0;i<this.headers_all.length;i++){
                    if(this.headers_all[i].pk===1){
                        primarykey=this.headers_all[i]["name"];
                    }
                    else{

                        let value=this.row_in_edit[this.headers_all[i]["name"]];
                        params=params+"&"+this.headers_all[i]["name"]+"="+value;
                    }
                }
                params+=params+"&pk_name="+primarykey+"&pk_value="+this.row_in_edit[primarykey];


                http.open('POST', url, true);

                http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
                let self=this;
                http.onreadystatechange = function() {//Call a function when the state changes.
                    console.log(http.readyState);
                    console.log(http.status);

                    if(http.readyState === 4 && http.status >= 400) {

                        self.$store.commit("update_snackbar","Ett fel inträffade");


                    }
                    else if(http.readyState === 4 && http.status === 200){
                        self.$store.commit("update_snackbar","Ändringar sparade");

                    }
                };
                console.log(params);
                http.send(params);
            },

            view_more:function(data){
                this.row_in_edit=data;
                this.edit_row=true;
            },

            get_schema:function(table){
                this.is_loading=true;
                let http = new XMLHttpRequest();
                http.withCredentials = true;
                let url = '/api/getSchema?';
                let params = 'TABLE='+table;
                http.open('POST', url, true);
                this.table=table;
                this.headers=[];
                http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
                let self=this;
                http.onreadystatechange = function() {//Call a function when the state changes.
                    if(http.readyState === 4 && http.status === 200){
                        let columnNames=JSON.parse(http.response);
                        self.headers_all=columnNames;
                        for(let i=0;i<columnNames.length;i++){
                            if(!self.headers_of_uninterest.includes(columnNames[i].name.toUpperCase())){
                                let column={
                                    text: columnNames[i].name,
                                    value: columnNames[i].name,
                                    filter:"",
                                    sortable: false,
                                    filterable: false

                                };
                                self.headers.push(column);
                            }

                        }
                      self.get_data();

                    }};
                http.send(params);
            },
            get_data:function(){
                let http = new XMLHttpRequest();
                http.withCredentials = true;
                let filter="";
                for(let i=0;i<this.headers.length;i++){
                  if(this.headers[i].filter===null || this.headers[i].filter===undefined){
                    this.headers[i].filter="";
                  }
                  else if(this.headers[i].filter!==""){
                    if(filter===""){
                      filter+=`${this.headers[i].text} LIKE '%${this.headers[i].filter}%'`
                    }else{
                      filter+=`AND ${this.headers[i].text} LIKE '%${this.headers[i].filter}%'`
                    }
                  }
                }

                let url = '/api/getAdminData?';
                let items_per_page=this.items_per_page;
                let start=(this.page*this.items_per_page);
                if(items_per_page<0){
                  items_per_page=this.total_length;
                  start=0;
                }
                let params = 'TABLE='+this.table+""+"&START="+start+`&COUNT=${items_per_page}`+"&FILTER="+filter;
                http.open('POST', url, true);
                http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
                let self=this;
                http.onreadystatechange = function() {//Call a function when the state changes.

                    if(http.readyState === 4 && http.status === 200){


                        let data=JSON.parse(http.response);
                        self.total_length=data.total_length;
                        if(((start))>=self.total_length){
                          self.force_page=1;
                        }
                        self.items=data.result;
                        /*for(let i=0;i<data.length;i++){

                        }*/
                        self.is_loading=false;

                    }
                    else if(http.readyState === 4 && http.status !== 200){
                      self.items=[];
                    }




                };
                http.send(params);
            }


        },
        computed:{
        },
        watch: {
          items_per_page:function(){
            this.get_data();
          }


        },
        mounted:function(){
            let self=this;
            setTimeout(function(){
                if(!self.$store.state.STREAMER.IS_ADMIN){
                    self.$router.push(`/404`)

                }
            },1000);


        }

    }
</script>

<style >
    .v-tabs-bar{
        background: transparent !important;
    }

    .theme--dark.v-data-table tbody tr:hover{
        background: rgba(255,255,255,0.1) !important;
    }

    .fillme{
        background: black;
    }

    .text-start{
        white-space: nowrap;
        font-size:14px !important;
    }

    .v-data-table__wrapper{
        min-height:400px;
    }
</style>
